import { collection, doc, getDoc, getDocs, setDoc } from "firebase/firestore";
import { db } from "../../firebase/config";

function summaryRef(competitionId, matchId) {
  return doc(db, "competitions", competitionId, "matches", matchId);
}

function matchesCol(competitionId) {
  return collection(db, "competitions", competitionId, "matches");
}

/** @type {import('./matchRepository.interface').MatchRepository} */
export const firestoreMatchRepository = {
  async getSummary(competitionId, matchId) {
    const snap = await getDoc(summaryRef(competitionId, matchId));
    return snap.exists() ? /** @type {import('../../domain/cmoe/match/matchTypes').MatchSummary} */ (snap.data()) : null;
  },
  async saveSummary(competitionId, summary) {
    await setDoc(summaryRef(competitionId, summary.matchId), summary, { merge: true });
  },
  async listSummaries(competitionId) {
    const snap = await getDocs(matchesCol(competitionId));
    const out = [];
    for (const d of snap.docs) {
      const s = await getDoc(summaryRef(competitionId, d.id));
      if (s.exists()) out.push(/** @type {import('../../domain/cmoe/match/matchTypes').MatchSummary} */ (s.data()));
    }
    return out;
  },
};
